import { Box } from "@mui/material";
import { Typography } from "src/components-mui/base/typography/typography";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { ITooltip } from "src/types/common";

export interface IIndicatorShellProps {
    /** Test ID for the root container */
    dataTestId: string;
    /** The tooltip configuration for this indicator */
    tooltip: ITooltip;
    /** Name/label of the indicator */
    indicatorName: string;
    /** Value of the indicator */
    indicatorValue: string;
}

export const IndicatorShell = ({ dataTestId, tooltip, indicatorName, indicatorValue }: IIndicatorShellProps) => {
    return (
        <Box
            component="dl"
            data-test-id={dataTestId}
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row", gap: 1 }}
        >
            <Box component="dt" sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                    sx={{
                        fontSize: "xs",
                    }}
                >
                    {indicatorName}
                </Typography>
                <WfPopover
                    content={tooltip.content}
                    link={tooltip.link}
                    PopoverTrigger={<PopoverButtonIconInfo ariaLabel={indicatorName} sx={{ ml: 1 }} />}
                />
            </Box>
            <Typography
                component="dd"
                sx={{
                    fontWeight: "bold",
                    fontSize: "xs",
                }}
            >
                {indicatorValue}
            </Typography>
        </Box>
    );
};
